import Coach1Image from 'assets/images/coaches/jakub-organista.png';
import Coach2Image from 'assets/images/coaches/piotr-noworol.jpg';
import Coach3Image from 'assets/images/coaches/jakub-langowski.jpg';

export const coaches = [
  {
    id: 1,
    name: 'Jakub Organista',
    image: Coach1Image,
    subtitle: '9 years in the sport, 3500+ jumps',
    description: {
      title: 'In VFS (Indoor Skydiving) with Ex-Presidents:',
      bulletPoints: [
        { id: 1, name: '- 4th place in the 4th FAI World Cup 2022' },
        { id: 2, name: '- 1st place in Czech Open 2022' },
        { id: 3, name: '- 2nd place in Flyspot Polish Open 2022/2021' },
        {
          id: 4,
          name: '- Polish Record holder in Head up and Head Down formation',
        },
      ],
    },
    additionalNote: undefined,
  },
  {
    id: 2,
    name: 'Piotr Novi Noworol',
    image: Coach2Image,
    subtitle: '10 years in the sport, 3500+ jumps',
    description: {
      title: 'In VFS (Indoor Skydiving) with Flyspot Synapses Team:',
      bulletPoints: [
        { id: 1, name: '- 1st place in the World Championship 2025r' },
        { id: 2, name: '- 1st place in the World Cup 2024r' },
        { id: 3, name: '- 1st place in the European Championship 2024r' },
        { id: 4, name: '- 3rd place in the World championships 2023' },
        { id: 5, name: '- 2nd place in the European Championships 2022' },
        { id: 6, name: '- 3rd place in the World Cup 2022' },
        {
          id: 7,
          name: '- 1st place in Polish, Austrian, Slovakian Championships',
        },
      ],
    },
    additionalNote:
      'Organizer and Polish record holder in the first Head up and Head down formation.',
  },
  {
    id: 3,
    name: 'Jakub Langowski',
    image: Coach3Image,
    subtitle: '19 years in the sport, 7500+ jumps',
    subtitle2: 'USPA S&TI, AFFI & Coach',
    records: [
      { id: 1, name: 'Current HeadUp World Record Holder (96-way)' },
      { id: 2, name: 'UK HU Record Holder & Organiser' },
      { id: 3, name: 'Polish HU Record Holder & Organiser' },
      { id: 4, name: 'HU & HD Big Ways & Records Organiser' },
    ],
    description: {
      title: 'VFS Mulitmedalist and Multichampion of:',
      bulletPoints: [
        { id: 1, name: '- Poland 2019, 2020, 2021,' },
        { id: 2, name: '- Austria 2019, 2020' },
        {
          id: 3,
          name: '- Czech Republic 2022',
        },
        { id: 4, name: '- as Team Poland: World Cup Belgium - 4th' },
      ],
    },
    additionalNote: 'VFS Coach for mutiple Teams (Civilian & Militaires)',
    additionalNote2:
      'Tunnel Coach and Instructor (Flyspot) with over 2500 hours of coaching and happy students.',
  },
];
